import { Place, FullAddress } from "~/shared/GoogleMapsInput/types";

export function fromPlaceToAddress(place: Place) {
    if (!place?.address_components) {
        return null;
    }

    const addressObj = place.address_components.reduce((acc: FullAddress, address) => {
        if (address.types.includes("street_number")) {
            acc.number = address.long_name;
        }

        if (address.types.includes("route")) {
            acc.address = address.long_name;
        }

        if (address.types.includes("sublocality_level_1")) {
            acc.neighborhood = address.long_name;
        }

        if (address.types.includes("administrative_area_level_2")) {
            acc.cityName = address.long_name;
        }

        if (address.types.includes("administrative_area_level_1")) {
            acc.uf = address.short_name;
        }

        if (address.types.includes("postal_code")) {
            acc.zipCode = address.long_name;
        }

        return acc;
    }, {});

    addressObj.fullAddress = place.formatted_address;
    try {
        addressObj.latitude = place?.geometry?.location?.lat() ?? null;
        addressObj.longitude = place.geometry.location.lng() ?? null;
    } catch (e) {
        addressObj.latitude = null;
        addressObj.longitude = null;
    }

    return addressObj;
}
